import styled from "styled-components";
import { color, typeStyle } from "@m/alchemy-theme";
export const Link = styled.a `
  align-items: center;
  appearance: none;
  background-color: transparent;
  border: none;
  color: ${color("typeLink")};
  cursor: pointer;
  font-size: inherit;
  font-weight: inherit;
  font-family: inherit;
  justify-content: center;
  line-height: inherit;
  margin: 0;
  padding: 0;
  text-align: center;
  > * {
    align-self: center;
  }
  &:active {
    color: inherit;
  }

  transition: color 200ms ease;

  ${typeStyle("link")};

  &:hover,
  &:focus {
    color: ${color("base", { palette: "interactiveConstructive" })};
  }
`;
